import { useQuery } from '@tanstack/react-query';
import {
  getAvailability,
  getMaintenancesReport,
  getAuditReport,
  getAuditFilters,
  getProbeSummary,
  getAvailableMonths,
} from '../api/reports.api.ts';
import type {
  AvailabilityParams,
  MaintenancesReportParams,
  AuditParams,
  ProbeSummaryParams,
} from '../api/reports.api.ts';

export const reportKeys = {
  availableMonths: ['reports', 'available-months'] as const,
  availability: (p: AvailabilityParams) => ['reports', 'availability', p] as const,
  maintenances: (p: MaintenancesReportParams) => ['reports', 'maintenances', p] as const,
  audit: (p: AuditParams) => ['reports', 'audit', p] as const,
  auditFilters: ['reports', 'audit', 'filters'] as const,
  probeSummary: (p: ProbeSummaryParams) => ['reports', 'probe-summary', p] as const,
};

export function useAvailableMonths() {
  return useQuery({
    queryKey: reportKeys.availableMonths,
    queryFn: getAvailableMonths,
    staleTime: 10 * 60_000,
  });
}

export function useAvailability(params: AvailabilityParams | null) {
  return useQuery({
    queryKey: reportKeys.availability(params ?? ({} as AvailabilityParams)),
    queryFn: () => getAvailability(params!),
    enabled: !!params,
  });
}

export function useMaintenancesReport(params: MaintenancesReportParams | null) {
  return useQuery({
    queryKey: reportKeys.maintenances(params ?? ({} as MaintenancesReportParams)),
    queryFn: () => getMaintenancesReport(params!),
    enabled: !!params,
  });
}

export function useAuditReport(params: AuditParams | null) {
  return useQuery({
    queryKey: reportKeys.audit(params ?? ({} as AuditParams)),
    queryFn: () => getAuditReport(params!),
    enabled: !!params,
  });
}

export function useAuditFilters() {
  return useQuery({
    queryKey: reportKeys.auditFilters,
    queryFn: getAuditFilters,
    staleTime: 10 * 60_000,
  });
}

export function useProbeSummary(params: ProbeSummaryParams | null) {
  return useQuery({
    queryKey: reportKeys.probeSummary(params ?? ({} as ProbeSummaryParams)),
    queryFn: () => getProbeSummary(params!),
    enabled: !!params,
  });
}
